import { createAction, props } from '@ngrx/store';

import { ISelectData } from '@shared/types';

export const UPDATE_SELECT_SELECTION = 'UPDATE_SELECT_SELECTION';
export const CLEAR_SELECT_SELECTION = 'CLEAR_SELECT_SELECTION';

export const update_selected_data = createAction(
    `[SELECT_REDUCER] ${UPDATE_SELECT_SELECTION}`,
    props<{ selectData: ISelectData }>(),
);

export const clear_selected_data = createAction(`[SELECT_REDUCER] ${CLEAR_SELECT_SELECTION}`);
